<kt-portlet>
    <kt-portlet-header [title]="getComponentTitle()"
                       [class]="'card-head-lg'"
                       [tooltipTitle]="'TOOLTIP.OFFICE.FORM'+(ac && ac.id > 0 ? '_EDIT':'')+'.TITLE' | translate"
                       [tooltipDesc]="'TOOLTIP.OFFICE.FORM'+(ac && ac.id > 0 ? '_EDIT':'')+'.DESCRIPTION' | translate"
                       [viewLoading$]="loading$"
                       [sticky]="true">
        <ng-container ktAdditionalTools>
            <div class="btn-group btn-group-toggle" role="group" ngbRadioGroup name="radioBasic" [formControl]="formSelectionCtrl">
                <label ngbButtonLabel class="btn btn-secondary width-130 btn-border-right-white">
                    <input ngbButton type="radio" class="btn-check" [value]="2"> Simple
                  </label>
                <label ngbButtonLabel class="btn btn-secondary width-130 btn-border-left-white">
                  <input ngbButton type="radio" class="btn-check" [value]="1"> Advanced
                </label>
            </div>
        </ng-container>
        <ng-container ktPortletTools>
            <a href="javascript:;"
               (click)="back()"
               class="btn mr-2" mat-raised-button matTooltip="Back to Office List">
                <mat-icon>arrow_back</mat-icon>
                <span class="kt-hidden-mobile">Close</span>
            </a>
            <a href="javascript:;"
                class="btn btn-success mr-2"
                color="warn"
                style="background-color: orange !important;"
                (click)="onSubmit(false)"
                mat-raised-button
                matTooltip="Save to Draft">
                <span>Save draft</span>
            </a>
            <a href="javascript:;"
               mat-raised-button
               class="btn btn-success mr-2"
               color="submit"
               (click)="onSubmit(true)"

               matTooltip="Save">
                <span class="kt-hidden-mobile">Save</span>
            </a>
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>
        <form class="form" [formGroup]="form" *ngIf="form">
            <!-- <kt-tab-header 
                [headerLabels]="tabHeaders" 
                (tabChange)="onTabChange($event)"
                [selectedTabChange]="selectedtabchange$">
            </kt-tab-header> -->
            <kt-form-tab-header
                [headers]="formTabHeaders$|async"
                (tabChange)="onTabChange($event)"
            ></kt-form-tab-header>
            <mat-tab-group class="invinsible-tabs" [(selectedIndex)]="selectedTab" (selectedTabChange)="onTabChanged($event);">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Location & building</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <div class="card-body-progress">
                            <mat-spinner [diameter]="20"></mat-spinner>
                        </div>
        
                        <!-- Location Section -->
                        <app-comparable-location
                            [centerLatitude]="centerLat"
                            [centerLongitude]="centerLng"
                            [requireCoordinates]="false"
                            [countrySelectable]="true"
                            [citySelectable]="true"
                            [locationInfo]="locationInfo"
                            (centerChange)="onCenterChangeV2($event)"
                            (markerChange)="onMarkerChangeV2($event)"
                        ></app-comparable-location>
                        <kt-building-form
                            *ngIf="isComplexForm"
                            [(centerLat)]="centerLat"
                            [(centerLng)]="centerLng"
                            (centerChange)="onCenterChange($event)"
                            (picChange)="onPicChange($event)"
                            [buildingPictures]="ac.building_info.pictures"
                            [buildingPicturePath]="ac.building_info.picture"
                            [isComplexForm]="isComplexForm"
                            [acBuilding]="ac.buildingInfo"
                            ></kt-building-form>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Property information</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <div class="form-group kt-form__group row section-margin-top-60">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                   About the property 
                                </h5>
                                <hr class="active">
                            </div>
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['sub_type_category_id']">
                                    <mat-select placeholder="Sub-type category" formControlName="sub_type_category_id">
                                        <mat-option *ngFor="let item of (filteredSubTypeCategories|async)" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="form.controls['sub_type_category_id']">
                                        Sub-type category <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Sub-type category <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="filteredSubCategories.length != 0">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['sub_category_id']">
                                    <mat-select placeholder="Sub-category" formControlName="sub_category_id">
                                        <mat-option *ngFor="let item of filteredSubCategories" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="form.controls['sub_type_category_id']">
                                        Sub-category <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Sub-category <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
        
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['handover_standard_id']">
                                    <mat-select placeholder="Handover standard" formControlName="handover_standard_id">
                                        <mat-option *ngFor="let item of handoverStandards" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="form.controls['handover_standard_id']">
                                        Handover standard <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Handover standard <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-8 kt-margin-bottom-10-mobile">
                                <tag-input 
                                    [tagFormFieldState]="floorLocationFormControl"
                                    class="floor" matInput formControlName="floor_details"
                                        [placeholder]="'RETAIL_SHOP.FORM.FIELD.CHARACTERISTICS.FLOOR_DETAILS.PLACEHOLDER' | translate"
                                        [secondaryPlaceholder]="'RETAIL_SHOP.FORM.FIELD.CHARACTERISTICS.FLOOR_DETAILS.PLACEHOLDER' | translate"
                                        (onAdd)="onFloorAdd($event)"
                                        (onRemove)="onFloorRemove($event)"
                                        modelAsStrings="true"
                                        style="width: 100%"
                                >
                                </tag-input>
                                <mat-error 
                                    [tagErrorState]="floorLocationFormControl">
                                    Floor location <strong>required</strong>
                                </mat-error>
                            </div>            
                            <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['state_of_repair_id']">
                                    <mat-select placeholder="State of repair" formControlName="state_of_repair_id">
                                        <mat-option *ngFor="let item of stateOfRepairs" [value]="item.id">{{item.name}}</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="form.controls['state_of_repair_id']">
                                        State of Repair <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        State of Repair <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4" *ngIf="!isComplexForm">
                                <mat-form-field class="mat-form-field-fluid">
                                    <input matInput placeholder="Building ID" formControlName="building_name">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4" *ngIf="!isComplexForm">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['building_type']">
                                    <mat-select placeholder="Building Type" formControlName="building_type">
                                        <mat-option *ngFor="let type of buildingTypes" [value]="type.id">
                                            {{type.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="form.controls['building_type']">
                                        Building type <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Building type <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-12" *ngIf="!isComplexForm && form.controls.building_type.value != null">
                                <mat-form-field class="mat-form-field-fluid">
                                    <textarea matInput placeholder="Building Type Comment" formControlName="building_type_comment"></textarea>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <mat-form-field class="mat-form-field-fluid">
                                    <textarea matInput placeholder="Property general description" formControlName="general_desc"></textarea>
                                </mat-form-field>
                            </div>
        
                            <div class="col-lg-12 mt-10" *ngIf="isComplexForm">
                                <kt-accommodation-layout-table
                                    [propertySubTypeID]="3"
                                    [aboveFloor]="aboveFloor$"
                                    [belowFloor]="belowFloor$"
                                    [floors$]="floors$"
                                    [initData]="ac.accommodation.data"
                                    [initOthers]="ac.accommodation.others"></kt-accommodation-layout-table>
                            </div>
                        </div>
        
                        <div class="form-group kt-form__group row section-margin-top-60" *ngIf="isComplexForm">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                   Internal Aspect 
                                </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-internal-aspects 
                                    [propertySubTypeID]="3" 
                                    [formType]="'comparable'"
                                    [internalAspectData]="ac.internalAspectData"></kt-internal-aspects>
                            </div>
                        </div>
                        <div class="form-group kt-form__group row section-margin-top-60">
                            <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                <h5 class="my-3 text-mad text-uppercase">
                                   Grounds & External Areas
                                </h5>
                                <hr class="active">
                            </div>
                            <div class="col-lg-12">
                                <kt-ac-grounds 
                                    [isComplexForm]="isComplexForm" 
                                    [propertySubTypeID]="3"
                                    [initData]="ac.grounds"></kt-ac-grounds>
                            </div>
                        </div>
                        <kt-ac-size class="section-margin-top-60" [sizesSubject]="sizesSubject" [assetClassType]="'3'"></kt-ac-size>
                        <mat-error 
                            errorStateWithLength
                            [hasFormError]="hasFormErrors"
                            [isInValid]="sizesSubject.value.length === 0"
                            [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                field: ('RETAIL_SHOP.FORM.FIELD.SIZES.SECTION_TITLE' | translate)
                            }"
                        >
                        </mat-error>
                    </div>
                </mat-tab>
                <mat-tab>
                    <kt-esg-indicators 
                        formType="comparable"
                        [value]="ac.esgIndicator"
                        [systemOfMeasurement]="userUnitOfMeasurementId$|async"/>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Lease & sale information</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <kt-consideration-and-source
                            style="margin-top: 60px;"
                            [inputConsiderations]="tenuresSubject|async"
                            [landAreaComponentListSubject]="comps"
                            [hasParcelInfo$]="hasParcel"
                            [timezoneOffset]="timezoneOffset"
                            [sizes]="sizes$|async"
                            (considerationsChange)="onConsiderationsChange($event)"
                            ></kt-consideration-and-source>
                        <mat-error 
                            errorStateWithLength
                            [hasFormError]="hasFormErrors"
                            [isInValid]="considerationError$|async"
                        >
                            Input <strong>required</strong>
                        </mat-error>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span>Pictures & documents</span>
                    </ng-template>
                    <div class="card-body pt-0 mad-container">
                        <div class="form-group row section-margin-top-60">
                            <div class="col-lg-12">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Property Pictures
                                </h5>
                                <hr class="active">
                            </div>
        
                            <kt-upload-file #simple class="col-lg-12"
                                [filesOnEditMode]="ac.ac_pictures"
                                [folderOnEditMode]="ac.picture"
                                [readOnly]="false"
                                [parentForm]="'land'"
                                [typeField]="false"
                                fileType="image/*"
                                split="1"
                                [featuredPictureAllowed]="true"
                                [hasThumbnail]="true"
                                [addButtonLabel]="'Add Office Picture'"
                                [dragAndDrop]="true">
                            </kt-upload-file>
                            <div class="col-md-12 kt-margin-bottom-20-mobile">
                                <mat-error 
                                    class="tag-custom-error" 
                                    *ngIf="hasFormErrors && showTitleRequiredError$|async">
                                    Picture should have a <strong>Title</strong>
                                </mat-error>
                            </div>
                        </div>
                        <div class="form-group row section-margin-top-60" *ngIf="isComplexForm">
                            <div class="col-lg-12">
                                <h5 class="my-3 text-mad text-uppercase">
                                    Building Pictures
                                </h5>
                                <hr class="active">
                            </div>
                            <kt-upload-file #buildingPic class="col-lg-12"
                                [filesOnEditMode]="ac.building_info.pictures"
                                [folderOnEditMode]="ac.building_info.picture"
                                [readOnly]="false"
                                [parentForm]="'land'"
                                [typeField]="false"
                                fileType="image/*"
                                split="2"
                                [featuredPictureAllowed]="true"
                                [hasThumbnail]="true"
                                [addButtonLabel]="'Add Building Picture'"
                                [dragAndDrop]="true">
                            </kt-upload-file>
                            <div class="col-md-12 kt-margin-bottom-20-mobile">
                                <mat-error class="tag-custom-error" *ngIf="showTitleRequiredError$|async">
                                    Picture should have a <strong>Title</strong>
                                </mat-error>
                            </div>
                        </div>
                        <kt-ac-document-upload class="section-margin-top-60" [files]="ac.documents" *ngIf="isComplexForm">
                        </kt-ac-document-upload>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </form> 
    </kt-portlet-body>
</kt-portlet>